export const links = [
  { path: '#hero', name: 'Home' },
  { path: '#about', name: 'About' },
  { path: '#gallery', name: 'Gallery' },
  { path: '#events', name: 'Gigs' }
];